/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SBE Conduct API
 * OpenAPI spec version: 1.0
 */
import {
  HttpClient,
  HttpHeaders,
  HttpResponse as AngularHttpResponse
} from '@angular/common/http';
import type {
  HttpContext,
  HttpEvent,
  HttpParams
} from '@angular/common/http';

import {
  Injectable,
  inject
} from '@angular/core';

import {
  Observable
} from 'rxjs';

import type {
  ListMyScoresResponseDto,
  ListScoresResponseDto,
  ScoresControllerListParams,
  TeamScoresControllerListParams
} from './models';




interface HttpClientOptions {
  readonly headers?: HttpHeaders | Record<string, string | string[]>;
  readonly context?: HttpContext;
  readonly params?:
        | HttpParams
      | Record<string, string | number | boolean | Array<string | number | boolean>>;
  readonly reportProgress?: boolean;
  readonly withCredentials?: boolean;
  readonly credentials?: RequestCredentials;
  readonly keepalive?: boolean;
  readonly priority?: RequestPriority;
  readonly cache?: RequestCache;
  readonly mode?: RequestMode;
  readonly redirect?: RequestRedirect;
  readonly referrer?: string;
  readonly integrity?: string;
  readonly referrerPolicy?: ReferrerPolicy;
  readonly transferCache?: {includeHeaders?: string[]} | boolean;
  readonly timeout?: number;
}

type HttpClientBodyOptions = HttpClientOptions & {
  readonly observe?: 'body';
};

type HttpClientEventOptions = HttpClientOptions & {
  readonly observe: 'events';
};

type HttpClientResponseOptions = HttpClientOptions & {
  readonly observe: 'response';
};

type HttpClientObserveOptions = HttpClientOptions & {
  readonly observe?: 'body' | 'events' | 'response';
};

type AngularHttpParamValue = string | number | boolean | Array<string | number | boolean>;
type AngularHttpParamValueWithNullable = AngularHttpParamValue | null;

function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys?: ReadonlySet<string>,
  preserveRequiredNullables?: false,
  passthroughKeys?: undefined,
): Record<string, AngularHttpParamValue>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> | undefined,
  preserveRequiredNullables: true,
  passthroughKeys?: undefined,
): Record<string, AngularHttpParamValueWithNullable>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> | undefined,
  preserveRequiredNullables: boolean | undefined,
  passthroughKeys: ReadonlySet<string>,
): Record<string, unknown>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> = new Set(),
  preserveRequiredNullables = false,
  passthroughKeys: ReadonlySet<string> = new Set(),
): Record<string, unknown> {
  const filteredParams: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(params)) {
    if (passthroughKeys.has(key)) {
      if (value !== undefined) {
        filteredParams[key] = value;
      }
      continue;
    }
    if (Array.isArray(value)) {
      const filtered = value.filter(
        (item) =>
          item != null &&
          (typeof item === 'string' ||
            typeof item === 'number' ||
            typeof item === 'boolean'),
      ) as Array<string | number | boolean>;
      if (filtered.length) {
        filteredParams[key] = filtered;
      }
    } else if (value === null && requiredNullableKeys.has(key)) {
      // With a paramsSerializer (preserveRequiredNullables) the literal null
      // is passed through for it to consume; without one, emit an empty
      // string so the required key still reaches the wire as `?key=`
      // instead of being silently dropped. See #3712.
      filteredParams[key] = preserveRequiredNullables ? null : '';
    } else if (
      value != null &&
      (typeof value === 'string' ||
        typeof value === 'number' ||
        typeof value === 'boolean')
    ) {
      filteredParams[key] = value;
    }
  }
  return filteredParams;
}





@Injectable({ providedIn: 'root' })
export class ScoresService {
  private readonly http = inject(HttpClient);
/**
 * 누적 상점·유효 벌점을 돌려준다. `memberIds`를 생략하면 org 전체, 넘기면 그 목록만 반환한다. 반 단위는 `GET /orgs/:orgId/teams/:teamId/scores`를 쓴다. 교직원이 아니면 403이다 — 본인 것만 보려면 `GET /me/orgs/:orgId/scores`를 쓴다. 명단(이름·반)은 이 API의 책임이 아니다 — `GET /orgs/:orgId/members?includeTeams=true`에서 받는다. `include=lastDemeritAt`이면 학생마다 최근 벌점일(`lastDemeritAt`)을 붙인다.
 * @summary 학생 상벌점 조회 (교직원 전용)
 */
 scoresControllerList<TData = ListScoresResponseDto>(orgId: string,
    params?: ScoresControllerListParams, options?: HttpClientBodyOptions): Observable<TData>;
 scoresControllerList<TData = ListScoresResponseDto>(orgId: string,
    params?: ScoresControllerListParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 scoresControllerList<TData = ListScoresResponseDto>(orgId: string,
    params?: ScoresControllerListParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  scoresControllerList<TData = ListScoresResponseDto>(
    orgId: string,
    params?: ScoresControllerListParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/orgs/${orgId}/scores`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/orgs/${orgId}/scores`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `/orgs/${orgId}/scores`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }
/**
 * 교직원 여부를 가리지 않는다 — 호출자가 연락처로 걸린 자리(본인 자리 + 학생 자리의 보호자 자리)의 점수만 돌려준다. 각 줄에 자리 이름(`name`, 보호자면 자녀 이름)·반(`teamId`)·자격(`relation`)을 붙인다 — 보호자는 명단 API를 읽을 수 없기 때문이다. 걸린 자리가 없으면 빈 배열이다(에러 아님).
 * @summary 본인 상벌점 조회 (누구나)
 */
 meScoresControllerList<TData = ListMyScoresResponseDto>(orgId: string, options?: HttpClientBodyOptions): Observable<TData>;
 meScoresControllerList<TData = ListMyScoresResponseDto>(orgId: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 meScoresControllerList<TData = ListMyScoresResponseDto>(orgId: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  meScoresControllerList<TData = ListMyScoresResponseDto>(
    orgId: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/me/orgs/${orgId}/scores`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/me/orgs/${orgId}/scores`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `/me/orgs/${orgId}/scores`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
/**
 * 이 반(teamId) 학생들의 누적 상점·유효 벌점을 돌려준다. 교직원이 아니면 403이다. `include=lastDemeritAt`이면 학생마다 최근 벌점일(`lastDemeritAt`)을 붙인다.
 * @summary 반 학생 상벌점 조회 (교직원 전용)
 */
 teamScoresControllerList<TData = ListScoresResponseDto>(orgId: string,
    teamId: string,
    params?: TeamScoresControllerListParams, options?: HttpClientBodyOptions): Observable<TData>;
 teamScoresControllerList<TData = ListScoresResponseDto>(orgId: string,
    teamId: string,
    params?: TeamScoresControllerListParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 teamScoresControllerList<TData = ListScoresResponseDto>(orgId: string,
    teamId: string,
    params?: TeamScoresControllerListParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  teamScoresControllerList<TData = ListScoresResponseDto>(
    orgId: string,
    teamId: string,
    params?: TeamScoresControllerListParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `/orgs/${orgId}/teams/${teamId}/scores`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `/orgs/${orgId}/teams/${teamId}/scores`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `/orgs/${orgId}/teams/${teamId}/scores`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }
};

